import ContractStatusModal from "./contract-status-modal.component";

export default ContractStatusModal;
